"use client";

import React from "react";
import { Card, Box, Typography, List, ListItem, LinearProgress } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";

const UserIntelligenceCard = ({ data = {} }) => {
    const sources = data.sources || [];
    const maxCount = Math.max(...sources.map((s) => s.count), 1);

    return (
        <Card
            sx={{
                boxShadow: "none",
                borderRadius: "7px",
                p: { xs: 2, sm: 3 },
                height: "100%",
                position: "relative",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    bgcolor: "rgba(255, 255, 255, 0.6)",
                    zIndex: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backdropFilter: "blur(1px)",
                }}
            >
                <Typography variant="h5" fontWeight="bold" color="text.secondary">
                    Coming Soon...
                </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={2} mb={3}>
                <Box
                    sx={{
                        color: "primary.main",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <EmailIcon sx={{ fontSize: 40 }} />
                </Box>
                <Box>
                    <Typography variant="caption" color="text.secondary" fontWeight={500}>
                        USER INTELLIGENCE
                    </Typography>
                    <Typography variant="h5" fontWeight={700}>
                        {data.total_emails?.toLocaleString()}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Total Email Captures
                    </Typography>
                </Box>
            </Box>

            <Typography variant="subtitle2" fontWeight={600} mb={1}>
                Capture Sources (Leaderboard)
            </Typography>

            <List disablePadding>
                {sources.map((item, index) => (
                    <ListItem key={index} sx={{ display: "block", px: 0, py: 1 }}>
                        <Box display="flex" justifyContent="space-between" mb={0.5}>
                            <Typography variant="body2" fontWeight={500}>
                                {item.source}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {item.count}
                            </Typography>
                        </Box>
                        <LinearProgress
                            variant="determinate"
                            value={(item.count / maxCount) * 100}
                            sx={{
                                height: 6,
                                borderRadius: 3,
                                bgcolor: "#F4F7FE",
                                "& .MuiLinearProgress-bar": {
                                    borderRadius: 3,
                                    bgcolor: "primary.main",
                                },
                            }}
                        />
                    </ListItem>
                ))}
            </List>
        </Card>
    );
};

export default UserIntelligenceCard;
